import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Crosssell5Component } from 'src/app/UI/view-models/register-funnels/cross-sell/crosssell5/crosssell5.component';
import { Crosssell7Component } from 'src/app/UI/view-models/register-funnels/cross-sell/crosssell7/crosssell7.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@NgModule({
  declarations: [
    Crosssell5Component,
    Crosssell7Component,
  ],
  imports: [
    CommonModule,
    SlickCarouselModule
  ],
  exports: [
    Crosssell5Component,
    Crosssell7Component
  ]
})
export class SharedCrossellModule { }
